import { MutationOptions, useMutation, useQueryClient } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";
import { useAuth } from "../context/AuthContext";
import { CREDIT_LIMIT_ELIGIBILITY_STATUS_KEY } from "./useCreditLimitEligibilityStatus";

function useCheckEligibility<T>(
  options?: MutationOptions<APIResponse<T>, APIError, void>
) {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const userId = user?.id;
  const {
    isLoading: checkingEligibility,
    isError: isCheckEligibilityError,
    error: checkEligibilityError,
    mutate: checkEligibility,
    data: eligibilityData,
  } = useMutation<APIResponse<T>, APIError, void>(
    async () => {
      return (await post(
        API_URL + "/account/user/eligibility/check",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )) as APIResponse<T>;
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        if (userId) {
          const queryKey = [CREDIT_LIMIT_ELIGIBILITY_STATUS_KEY, userId];
          await queryClient.invalidateQueries(queryKey);
        }
        options?.onSuccess?.(data, variables, context);
      },
    }
  );

  return {
    checkEligibility,
    checkingEligibility,
    isCheckEligibilityError,
    checkEligibilityError,
    eligibilityData,
  };
}

export default useCheckEligibility;
